import { useState } from 'react';
import { Banner, CloseButton, TextButton } from '@zillow/constellation-10';

import { AdminModal } from '../AdminModal';

import { useBannerVisibility } from '../../hooks/useBannerVisibility';

import type { Brand, User } from '../../types';

type MockUserNavProps = {
  brand: Brand | string;
  featureFlagPage: string;
  userModel: User | null;
};

export default function MockUserNav(props: MockUserNavProps): JSX.Element | null {
  const { isVisible, handleModalConfirm } = useBannerVisibility();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { userModel, brand, featureFlagPage } = props;
  const { email, userToken, isMocked } = userModel ?? {};

  const content = ` | brand: ${brand} | token: ${userToken} | email: ${email}`;

  if (!isMocked) {
    return null;
  }

  return (
    <>
      <Banner
        data-testid="MockUserNav"
        tone="warning"
        isOpen={isVisible}
        actionButton={
          <TextButton asChild onImpact>
            <a href={featureFlagPage}>Feature flags</a>
          </TextButton>
        }
        closeButton={<CloseButton onImpact />}
        onClose={() => setIsModalOpen(true)}
      >
        Mocked User{content}
      </Banner>
      <AdminModal
        isImpersonator={false}
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        onConfirm={handleModalConfirm}
      />
    </>
  );
}
